export const STEP_WRAPPER_MAX_WIDTH = 485;
